import agentAvatar from "../../assets/avatar.png";

export default function Loading() {
  return (
    <div className="vcw-row assistant">
      <div className="vcw-msg-avatar" aria-hidden="true">
        <img src={agentAvatar} alt="" className="vcw-avatar-img" />
      </div>
      <div
        className="vcw-typing vcw-bubble assistant"
        aria-label="Agent en train d’écrire"
      >
        <span className="vcw-typing-dot" aria-hidden="true" />
        <span className="vcw-typing-dot" aria-hidden="true" />
        <span className="vcw-typing-dot" aria-hidden="true" />
      </div>
    </div>
  );
}
